import React, { useRef } from 'react';
import _ from 'lodash';
import urlJoin from 'url-join';
import FrameMessages from '../const/FrameMessages';
import { renderModes } from '../const/AugmentationConst';
import CommerceUnit from '../augmentation/CommerceUnit';
import { getAdHostingWindow, getFrameId } from './utils';
import * as CampaignUtils from '../utils/CampaignUtils';
import * as BrowserUtils from '../utils/BrowserUtils';
import {injectHtml} from '../utils/DomUtils';
import settings from '../../config/settings';

const IframeCommerceUnit = (props) => {
  const trackingCodeContainer = useRef(null);

  const { campaignId, publisherId, renderer: { id: rendererId, renderMode, adRefreshInterval, productRefreshInterval, adRenderer, displayDuration } } = props;

  const renderCommerceUnit = () => {
    return (
      <CommerceUnit
        adRefreshInterval={adRefreshInterval}
        productRefreshInterval={productRefreshInterval}
        adRenderer={adRenderer}
        publisherId={publisherId}
        publisherName={publisherId}
        campaignId={campaignId}
        rendererId={rendererId}
        displayDuration={displayDuration}
        applyTrackingCodes={applyTrackingCodes}
        adTrackingId={getAdTrackingId()}
        publisherCssReset=""
      />
    );
  };

  const closePopup = () => {
    const frameId = getAdFrameId();
    getAdHostingWindow().postMessage({ title: FrameMessages.requestHide, frameId }, '*');
  };

  const getAdFrameId = () => {
    const { renderer, campaignId } = props;
    if (!renderer) {
      return null;
    }
    return getFrameId(renderer.id, null, campaignId);
  };

  const getAdTrackingId = () => {
    const {campaign, adTrackingId} = props;
    return adTrackingId || campaign.adTrackingId;
  };

  const getFbEventId = (eventType) => {
    const {campaign, campaignId, renderer, publisherId} = props;
    return CampaignUtils.getFbPixelEventId(
      campaign.userId,
      publisherId,
      getAdTrackingId(),
      campaignId,
      renderer.templateName,
      eventType
    );
  };

  const applyTrackingCodes = (eventType) => {
    const {renderer} = props;
    let codes = '';
    if (!_.isEmpty(renderer.trackingCodes)) {
      const deviceType = BrowserUtils.getDeviceType();
      const fbEventId = getFbEventId(eventType);
      renderer.trackingCodes.forEach((codeConfig) => {
          const code = CampaignUtils.getRendererTrackingCode(codeConfig, deviceType, eventType, fbEventId);
          if (code) {
            codes += code;
          }
        }
      );
      if (codes) {
        const wrapper = document.createElement('span');
        trackingCodeContainer.current.appendChild(wrapper);
        injectHtml(wrapper, codes);
      }
    }
  };

  const renderTrackingCodeContainer = () => {
    return (
      <span id="tracking-code"
            style={{position: 'absolute', bottom: '0', visibility: 'hidden'}}
            ref={trackingCodeContainer}
      />
    );
  };

  const renderAd = () => {
    if (renderMode === renderModes.iframeVupopup) {
      return (
        <React.Fragment>
          <a
            className="vupClosePopup"
            onClick={closePopup}
          >
            <img
              className="vupClosePopup__icon"
              src={urlJoin(settings.frontendBaseURL, '/static/icons/ad_close_with_label.svg')}
              alt="Close Ad"
            />
          </a>
          <div id="vup-ad-content">
            {
              renderCommerceUnit()
            }
          </div>
        </React.Fragment>
      );
    }

    if (renderMode === renderModes.iframeBottomBanner) {
      return (
        <React.Fragment>
          <a
            className="vupClosePopup"
            onClick={closePopup}
          >
            {'×'}
          </a>
          <div id="vup-ad-content">
            {
              renderCommerceUnit()
            }
          </div>
        </React.Fragment>
      );
    }
   return null;
  };

  return (
    <React.Fragment>
      {renderAd()}
      {renderTrackingCodeContainer()}
    </React.Fragment>
  );
};

export default IframeCommerceUnit;